export default __webpack_public_path__ + "static/media/Video.d986f974.svg";